import { Fragment } from 'react';
import { HeaderPage1 } from 'theme/elements/Headers';
import { Box } from '@mui/material';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useSelector } from 'react-redux';

export default function PrivacyApp() {
	const t = useSelector(selectTranslations);
	return (
		<Fragment>
			<Box sx={{ paddingX: '24px', paddingTop: '48px', paddingBottom: '80px' }}>
				<HeaderPage1 title={t('privacy.content.title.text')} />
				<Box marginTop="24px">
					<div dangerouslySetInnerHTML={{ __html: t('privacy.content.description.text') }}></div>
				</Box>
			</Box>
		</Fragment>
	);
}
